import KeyboardShortcutDisplay from '@ui/shared/components/Common/KeyboardShortcutDisplay';
import CONSTANTS from '../../../config/constants';
import { View, Text, Flex } from '@smarterservices/smarter-ui';

const Shortcuts = () => {
    const renderShortcutGroup = (groupKey, groupData) => {
        if (!groupData || !groupData.OPTIONS) return null;
    
        return (
          <View key={groupKey} margin="none none large none">
            <Text variant="contentImportant" margin="none none small none">
              {groupData.TITLE}
            </Text>
            <View>
              {Object.entries(groupData.OPTIONS).sort(([a], [b]) => a.localeCompare(b)).map(([optionKey, optionData]) => {
                // Handle nested options like BULK_EDIT and AUTO_SCROLL
                if (optionData.OPTIONS) {
                  return Object.entries(optionData.OPTIONS).sort(([a], [b]) => a.localeCompare(b)).map(([nestedKey, nestedData]) => (
                    <Flex key={`${optionKey}-${nestedKey}`} margin="none none x-small none" alignItems="center">
                      <Flex.Item shouldGrow>
                        <Text variant="content">
                          {nestedData.DESCRIPTION}
                        </Text>
                      </Flex.Item>
                      <Flex.Item>
                        <KeyboardShortcutDisplay shortcut={nestedData.KEY} />
                      </Flex.Item>
                    </Flex>
                  ));
                }
    
                // Handle regular options
                return (
                  <Flex key={optionKey} margin="none none xx-small small" alignItems="center">
                    <Flex.Item shouldGrow>
                      <Text variant="content">
                        {optionData.DESCRIPTION}
                      </Text>
                    </Flex.Item>
                    <Flex.Item>
                      <KeyboardShortcutDisplay shortcut={optionData.KEY} />
                    </Flex.Item>
                  </Flex>
                );
              })}
            </View>
          </View>
        );
      };
    
    
    return (
        <View as="div" margin="medium">
            {Object.entries(CONSTANTS.KEYBOARD_SHORTCUTS).map(([groupKey, groupData]) => 
                renderShortcutGroup(groupKey, groupData)
            )}
        </View>
    );
};

export default Shortcuts;
